const { LMap, LTileLayer, LMarker } = window.Vue2Leaflet;
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "LocationMap",
  props: ["lat_lng", "pZoom", "disableEditing"],
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data() {
    return {
      url: `${env.maps_api_client_url}tiles/osm-bright/{z}/{x}/{y}.png?apiKey=${env.maps_api_key}`,
      zoom: 12,
      bounds: null,
      showMap: false
    };
  },
  methods: {
    fixLayer() {
      this.map = this.$refs.myMap.mapObject;
      this.map.invalidateSize();
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    newPos(pos) {
      if (!this.disableEditing) {
        this.$emit("updatePosition", pos.target._latlng);
      }
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    setMarker(event) {
      if (!this.disableEditing) {
        this.$emit("updatePosition", event.latlng);
      }
    }
  }
};
